import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const thLarge: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M6-4v3a.96.96 0 0 1-.297.703A.96.96 0 0 1 5 0H1a.95.95 0 0 1-.703-.297A.95.95 0 0 1 0-1v-3a.96.96 0 0 1 .297-.703A.96.96 0 0 1 1-5h4c.27 0 .504.102.703.297.195.2.297.433.297.703m0-6v3a.96.96 0 0 1-.297.703A.96.96 0 0 1 5-6H1a.95.95 0 0 1-.703-.297A.95.95 0 0 1 0-7v-3a.96.96 0 0 1 .297-.703A.96.96 0 0 1 1-11h4c.27 0 .504.102.703.297.195.2.297.433.297.703m7 6v3a.96.96 0 0 1-.297.703A.96.96 0 0 1 12 0H8a.95.95 0 0 1-.703-.297A.95.95 0 0 1 7-1v-3a.96.96 0 0 1 .297-.703A.96.96 0 0 1 8-5h4c.27 0 .504.102.703.297.195.2.297.433.297.703m0-6v3a.96.96 0 0 1-.297.703A.96.96 0 0 1 12-6H8a.95.95 0 0 1-.703-.297A.95.95 0 0 1 7-7v-3a.96.96 0 0 1 .297-.703A.96.96 0 0 1 8-11h4c.27 0 .504.102.703.297.195.2.297.433.297.703m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "11",
    width: "13",
  }
};
